var map = {
	"./Logout.png": 1286,
	"./analyticsIcon.png": 1287,
	"./android-icon.png": 1288,
	"./apIcon.png": 1289,
	"./arrow-white.png": 1290,
	"./completed-orders-icon.svg": 1291,
	"./danger.png": 1292,
	"./danger2.png": 1293,
	"./driver-no-avatar.svg": 1294,
	"./favicon.png": 1295,
	"./flags.png": 1296,
	"./ic_settings.svg": 1297,
	"./img_icon_cars.png": 1298,
	"./in-progress-orders-icon.svg": 1299,
	"./info.png": 1300,
	"./ios-icon.png": 1301,
	"./location-icon.png": 1302,
	"./logo-dook.png": 1303,
	"./logo.png": 1304,
	"./logo.svg": 1305,
	"./map-markers/assigned.svg": 1306,
	"./map-markers/assigned_delivery.svg": 1307,
	"./map-markers/assigned_pickup.svg": 1308,
	"./map-markers/assigned_regular.svg": 1309,
	"./map-markers/driver-icon.svg": 1310,
	"./map-markers/onwaytodelivery.svg": 1311,
	"./map-markers/onwaytodelivery_regular.svg": 1312,
	"./map-markers/partlypickedup.svg": 1313,
	"./map-markers/partlypickedup_regular.svg": 1314,
	"./map-markers/pickedup.svg": 1315,
	"./map-markers/pickedup_regular.svg": 1316,
	"./map-markers/unassigned.svg": 1317,
	"./map-markers/unassigned_delivery.svg": 1318,
	"./map-markers/unassigned_pickup.svg": 1319,
	"./map-markers/unassigned_regular.svg": 1320,
	"./map-markers/waitingforpickup.svg": 1321,
	"./map-markers/waitingforpickup_regular.svg": 1322,
	"./map-markers/waitingforreturn.svg": 1323,
	"./map-markers/waitingforreturn_regular.svg": 1324,
	"./mapdrop.png": 1325,
	"./more.svg": 1326,
	"./mot.png": 555,
	"./mot.svg": 1327,
	"./nav-bar-icons/analytics.svg": 1328,
	"./nav-bar-icons/dashboard.svg": 1329,
	"./nav-bar-icons/logout.svg": 1330,
	"./nav-bar-icons/newOrder.svg": 1331,
	"./nav-bar-icons/settings.svg": 1332,
	"./new-orders-icon copy.svg": 1333,
	"./new-orders-icon.svg": 1334,
	"./newOrder.png": 1335,
	"./pic.png": 1336,
	"./pic.svg": 1337,
	"./popup.png": 1338,
	"./sed.png": 556,
	"./sed.svg": 1339,
	"./settings.png": 1340,
	"./side_bag.svg": 557,
	"./side_bigBag.svg": 558,
	"./side_cacheOnDelivery.svg": 559,
	"./side_cancelled.svg": 560,
	"./side_cod.svg": 1341,
	"./side_delivered.svg": 561,
	"./side_delivery.svg": 562,
	"./side_id_blue.svg": 563,
	"./side_id_red.svg": 564,
	"./side_id_violet.svg": 565,
	"./side_info.svg": 566,
	"./side_list.svg": 567,
	"./side_list_arrow.svg": 568,
	"./side_menu.svg": 569,
	"./side_pickup.svg": 570,
	"./side_pin_delivery.svg": 571,
	"./side_pin_failed.svg": 572,
	"./side_pin_pickup.svg": 573,
	"./side_pin_succeeded.svg": 574,
	"./side_pin_unassigned.svg": 575,
	"./side_returned.svg": 576,
	"./side_search.svg": 1342,
	"./side_watch.svg": 577,
	"./suv.png": 578,
	"./suv.svg": 1343,
	"./title.png": 579,
	"./title1.png": 580,
	"./van.png": 581,
	"./van.svg": 1344,
	"./warning.png": 1345,
	"./warning2.png": 1346
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1995;



//////////////////
// WEBPACK FOOTER
// ./src/images \.(jpe?g|png|svg|gif)$/
// module id = 1995
// module chunks = 0